import { Town } from '@/types/admin-town';
import { Empty, TableProps } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { useNavigate, useParams } from 'react-router-dom';
import { AppTable } from '../atoms';
import AppButton from '../atoms/AppButton';
import { EditFill } from '../atoms/AppIcon';
import { EMPTY_TEXT_FILTERED } from '@/constants';

interface TownTableProps {
  data: Town[];
  sortInfo?: {
    columnKey?: string;
    order?: 'ascend' | 'descend';
  };
  onTableChange?: (sorter: SorterResult<Town> | SorterResult<Town>[]) => void;
  isLoading?: boolean;
}

const TownTable = ({ data, sortInfo, onTableChange, isLoading }: TownTableProps) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const navigate = useNavigate();

  const columns: TableProps<Town>['columns'] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '8%',
    },
    {
      title: '名前',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'name' ? sortInfo.order : undefined,
      width: '25%',
    },
    {
      title: '郵便番号',
      key: 'postal_code',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'postal_code' ? sortInfo.order : undefined,
      render: (_, record) => (
        <span>
          {record.postal_code1}-{record.postal_code2}
        </span>
      ),
      width: '15%',
    },
    {
      title: '検索名',
      dataIndex: 'search_name',
      key: 'search_name',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'search_name' ? sortInfo.order : undefined,
      width: '27%',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <div className="flex gap-2">
          <AppButton
            icon={<EditFill />}
            type="primary"
            onClick={() => navigate(`/${currentSite}/admin/towns/${record.id}/edit`)}
          >
            編集
          </AppButton>
        </div>
      ),
      width: '25%',
    },
  ];

  return (
    <AppTable
      columns={columns}
      dataSource={data}
      rowKey={record => record.id}
      onChange={(_pagination, _filters, sorter) =>
        onTableChange?.(sorter as SorterResult<Town> | SorterResult<Town>[])
      }
      loading={isLoading}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_TEXT_FILTERED} />,
      }}
    />
  );
};

export default TownTable;
